webpackJsonp([212572594560358],{

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/Anjali-Mahajan.png";
	var icon2 = "https://winpeforum.com/assets/elements/manshachugani.jpg";
	var icon3 = "https://winpeforum.com/assets/elements/VarunaKhattri.jpg";
	var icon4 = "https://winpeforum.com/assets/elements/Kaushalya.avif";
	
	var duration = 400;
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    _this.Speaker2 = [{
	      imgUrl: icon4,
	      desc: "<div>\nKaushalya is a seasoned corporate lawyer. Her practice areas are mergers and acquisitions, private equity and venture capital. She represents both institutional funds, large MNCs as well as startups and has been consistently ranked in IFLR 1000 as a \u2018Notable Practitioner\u2019 consistently since 2022 and she has also been ranked in Legal 500.\n\n\n\n \n          </div>",
	      name: "Kaushalya Venkataraman ",
	      post: "<div>Partner<br/>\nChandhiok & Mahajan\n\n\n\n\n          </div>"
	    }];
	    _this.Speaker1 = [{
	      imgUrl: icon1,
	      desc: "<div>\nAnjali is an Investment Professional at Lighthouse Funds, where she has spent three years in Consumer investing. Before this, she spent four years in Investment Banking at Axis Capital. There, she advised mid-market Indian corporations on their fund-raise endeavours across the focus sectors of Chemicals, Pharma and Lifesciences, Logistics and Manufacturing.\n\n \n          </div>",
	      name: "Anjali Mahajan",
	      post: "<div>Investment Professional<br/>\nLighthouse Funds\n\n\n\n          </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>\nMansha Chugani is a Vice President in the Investor Relations &amp; Business\nDevelopment team at Everstone, based in Singapore. She plays an active role\nin fostering the firm\u2019s investor relationships and advancing the firm\u2019s\nsustainability initiatives.<br/><br/>\nBefore joining Everstone, Mansha spent six years at Partners Group, a global\ninvestment firm, working across Investor Relations and Product Management.<br/><br/>\nShe began her career at Infosys, a multinational IT company, where she built a\nstrong foundation in analytical and strategic skills.<br/><br/>\nMansha holds a Bachelor of Engineering degree in Computer Science.\n\n\n\n          </div>",
	      name: "Mansha Chugani",
	      post: "<div>Vice President (Investor Relations)<br/>\nEverstone\n\n\n          </div>"
	    }, {
	      imgUrl: icon3,
	      desc: "<div>\n  Varuna Khattri is an investment professional in the Real Assets group at CPP Investments, with around a decade of experience across the full investment lifecycle, including transaction execution, asset management, and value creation. She has worked on complex investments in sectors including transport and highways, ports and logistics, telecom, data centres, and energy transition sectors, contributing to investment decision-making and long-term capital deployment. Varuna holds an MBA from IIM Shillong and is a graduate of Hindu College, University of Delhi. \n\n          </div>",
	      name: "Varuna Khattri",
	      post: "<div>Investment Professional<br/>\nCPPIB\n\n\n          </div>"
	    }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Winpe Ignite Career Talk Session",
	        image: "https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png",
	        description: "On 21st February 2026, we hosted another edition of Winpe\u2019s Ignite Career Talk Series \u2014 this time in a masterclass format centered around the theme \u201CIf I Were Starting My PE/VC Career Today: Senior Investors Reflect on What They\u2019d Do Differently in Today\u2019s Market.\u201D\r\n",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                " Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "Winpe Ignite Career Talk Series ",
	              _react2.default.createElement("br", null),
	              "If I Were Starting My PE/VC Career Today "
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "February 21, 2026"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Online"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "On 21st February 2026, we hosted another edition of Winpe\u2019s Ignite Career Talk Series \u2014 this time in a masterclass format centered around the theme \u201CIf I Were Starting My PE/VC Career Today: Senior Investors Reflect on What They\u2019d Do Differently in Today\u2019s Market.\u201D",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The session brought together senior women investors who shared candid reflections on their early career decisions, pivotal mistakes, defining moments, and how the PE/VC landscape has evolved over the years. The conversation moved beyond technical skills and focused on judgment, conviction, risk assessment, networking, and long-term career building in an increasingly competitive and technology-driven market.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The discussion offered practical guidance for aspiring professionals \u2014 particularly those navigating early career stages or considering transitions into Private Equity and Venture Capital.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Catch the full recording ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://www.youtube.com/watch?v=D6cYDRUFlIw", target: "_blank", style: { color: 'blue', textDecoration: 'underline' } },
	                "here"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Through sessions like these, Winpe continues its mission to empower women with the tools and perspective they need to enter and thrive in the ever-evolving culture of PEVC.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h3",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Key Highlights:"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Start with clarity, not complexity"
	                    )
	                  ),
	                  "The speakers emphasized that many early-career professionals equate complexity with sophistication. However, the strongest investment theses are often simple, clearly articulated, and rooted in structured thinking. Being able to explain what a business does, how it creates value, and what risks exist \u2014 in simple terms \u2014 signals true depth of understanding."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Build structured thinking and commercial judgment early"
	                    )
	                  ),
	                  " Financial modelling is foundational, but it is only hygiene. What differentiates strong investors is commercial instinct \u2014 understanding management quality, regulatory dynamics, sector shifts, and behavioral signals that cannot always be captured in spreadsheets."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Develop a personal point of view"
	                    )
	                  ),
	                  "Tracking sectors, writing investment theses, debating ideas, and building independent conviction were highlighted as critical career accelerators. A differentiated perspective demonstrates readiness for larger responsibilities within investment teams."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Networking compounds over time"
	                    )
	                  ),
	                  " The speakers underscored the importance of proactive outreach \u2014 attending industry events, speaking to professionals, and maintaining long-term relationships. Networks often evolve into deal flow sources, mentors, advocates, and long-term career supporters."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Focus on learning, not just brand names"
	                    )
	                  ),
	                  " Early career decisions should prioritize exposure and learning opportunities over prestigious firm names. Depth of experience, curiosity, and initiative shape long-term trajectory more than logos on a resume."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Confidence is calm clarity, not dominance"
	                    )
	                  ),
	                  " Effective investors are not necessarily the loudest voices in the room. Clear articulation of risks, structured communication in IC discussions, and thoughtful framing of downside scenarios build credibility over time."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "AI will accelerate analysis \u2014 but not replace judgment"
	                    )
	                  ),
	                  " The session also explored AI\u2019s growing presence in investing. While AI can improve efficiency in document review, benchmarking, and sensitivity analysis, final underwriting decisions, accountability, and capital allocation remain fundamentally human responsibilities."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h3",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Q&A Highlights:"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Audience questions covered transitions from capital markets and consulting into PE funds, positioning CVs for investment roles, building conviction when pitching ideas internally, and navigating non-traditional career paths into investing."
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { "class": "row" },
	              _react2.default.createElement(
	                "div",
	                { "class": "col-md-12" },
	                _react2.default.createElement(
	                  "h2",
	                  { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                  "Speakers"
	                ),
	                "          ",
	                _react2.default.createElement("div", { "class": "r_btm" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '80%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker1.map(function (item, i) {
	                          if (i <= 12) {
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-4 col-sm-12 col-lg-4",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          } else return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-6 col-sm-12 col-lg-6",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "row" },
	              _react2.default.createElement(
	                "div",
	                { "class": "col-md-12" },
	                _react2.default.createElement(
	                  "h2",
	                  { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                  "Moderator"
	                ),
	                "          ",
	                _react2.default.createElement("div", { "class": "r_btm" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '50%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker2.map(function (item, i) {
	                          if (i <= 12) {
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-12 col-sm-12 col-lg-12",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          } else return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-6 col-sm-12 col-lg-6",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ignite-session-21-feb-2026-index-js-c6b8c8afa012912b7df2.js